// Application Configuration Constants
export const APP_CONFIG = {
  name: 'VReels Shop',
  version: '1.0.0',
  description: 'Vendor management platform for VReels Shop',
  support: {
    phone: '+1 (555) 123-4567',
    email: 'support@vreelsshop.com',
    hours: '9 AM - 6 PM'
  }
};

export const API_ENDPOINTS = {
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  auth: {
    checkPhone: '/auth/check-phone',
    verifyOtp: '/auth/verify-otp'
  }
};

export const VALIDATION_RULES = {
  phone: {
    minLength: 10,
    maxLength: 15,
    pattern: /^\d+$/
  },
  otp: {
    length: 6,
    pattern: /^\d{6}$/
  }
};

export const TIMEOUTS = {
  otpResend: 300000, // 5 minutes in milliseconds
  apiRequest: 30000, // 30 seconds
  debounce: 300 // 300ms for input debouncing
};

export const COUNTRY_CODES = [
  { code: '+1', country: 'US' },
  { code: '+91', country: 'IN' },
  { code: '+44', country: 'UK' },
  { code: '+86', country: 'CN' },
  { code: '+81', country: 'JP' },
  { code: '+49', country: 'DE' },
  { code: '+33', country: 'FR' },
  { code: '+61', country: 'AU' },
  { code: '+55', country: 'BR' },
  { code: '+7', country: 'RU' },
];

export default APP_CONFIG;
